import {
  LayoutDashboard,
  Users,
  GitBranch,
  PhoneCall,
  MessageSquare,
  KanbanSquare,
  Network,
  LineChart,
  Zap,
} from "lucide-react";

export const NAV_ITEMS = [
  {
    label: "Dashboard",
    path: "/",
    icon: LayoutDashboard,
    testId: "nav-dashboard",
  },
  {
    label: "Lead Intake & Scoring",
    path: "/lead-intake",
    icon: Users,
    testId: "nav-lead-intake",
    description: "Ingest inbound MQLs, score by ICP fit, intent signals, and buying-stage triggers.",
  },
  {
    label: "Nurture Sequence Builder",
    path: "/sequence-builder",
    icon: GitBranch,
    testId: "nav-sequence-builder",
    description: "Visual multi-touch sequences across email, SMS, and voice with branching logic.",
  },
  {
    label: "Voice Follow-Up Agent",
    path: "/voice-agent",
    icon: PhoneCall,
    testId: "nav-voice-agent",
    description: "Voiceflow-powered outbound calls, voicemail drops, and inbound qualification.",
  },
  {
    label: "Email & SMS Automation",
    path: "/email-sms",
    icon: MessageSquare,
    testId: "nav-email-sms",
    description: "Make.com sequences with 98% SMS open rate leverage and adaptive send-time AI.",
  },
  {
    label: "Conversion Pipeline",
    path: "/pipeline",
    icon: KanbanSquare,
    testId: "nav-pipeline",
    description: "Kanban view of leads by stage — MQL → SQL → Demo → Closed / Won.",
  },
  {
    label: "Agent Orchestration",
    path: "/orchestration",
    icon: Network,
    testId: "nav-orchestration",
    description: "See how Voice, Email, SMS, and Scoring agents coordinate handoffs in real time.",
  },
  {
    label: "Growth Intel",
    path: "/growth-intel",
    icon: LineChart,
    testId: "nav-growth-intel",
    description: "Benchmark analytics: your conversion rate vs. medical-device manufacturer top performers.",
  },
  {
    label: "Flagship: Conversion Velocity Engine",
    path: "/velocity-engine",
    icon: Zap,
    testId: "nav-velocity-engine",
    description: "The end-to-end AI system compressing time-to-demo from 47 days to 6.",
    flagship: true,
  },
];
